<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-input size="small" v-model="query.phone" clearable maxlength="12" placeholder="号码" style="width: 180px;"
                  class="handle-input mr10"></el-input>
        <el-select size="small" v-model="query.logType" clearable placeholder="日志类型" style="width: 180px;"
                   class="handle-select mr10">
          <el-option :value="null" label="全部"></el-option>
          <el-option value="ORDER_CREATE" label="订单创建"></el-option>
          <el-option value="IMMEDIATE_ARRIVAL" label="立即到账"></el-option>
          <el-option value="NEXT_MONTH_ARRIVAL" label="次月到账"></el-option>
        </el-select>
        <el-select size="small" v-model="query.source" clearable placeholder="来源" style="width: 180px;"
                   class="handle-select mr10">
          <el-option :value="null" label="全部"></el-option>
          <el-option value="PUBLIC_ACCOUNT" label="公众号充值"></el-option>
          <el-option value="BATCH_TOPUP" label="后台批量"></el-option>
          <el-option value="FILE_RECHARGE" label="文件充值"></el-option>
        </el-select>
        <el-input size="small" v-model="query.operatorAccount" clearable placeholder="操作人" style="width: 150px;"
                  class="handle-input mr10"></el-input>
        <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" @click="getData">搜索</el-button>
        <el-button size="small" type="info" :class="[theme]" icon="el-icon-refresh" @click="resetQuery">重置</el-button>
      </div>

      <el-table
          :key="tableKey"
          :data="tableData"
          border
          class="table"
          ref="multipleTable"
          header-cell-class-name="table-header"
          max-height="600"
          :row-style="{ height: '20px' }"
          :cell-style="{ padding: '6px' }"
          :header-cell-style="{ 'text-align': 'center' }"
          stripe
          v-loading="loading">
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        
        <el-table-column label="日志类型" width="120" align="center">
          <template #default="scope">
            <el-tag v-if="scope.row" :type="getLogTypeTag(scope.row.logType)" size="small">
              {{ getLogTypeText(scope.row.logType) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="来源" width="120" align="center">
          <template #default="scope">
            <el-tag v-if="scope.row" :type="getSourceTag(scope.row.source)" size="small">
              {{ getSourceText(scope.row.source) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="phone" label="号码" width="120" align="center"></el-table-column>

        <el-table-column prop="yearMonth" label="套餐周期" width="100" align="center"></el-table-column>

        <el-table-column prop="packagesName" label="运营商套餐" width="200" align="center" show-overflow-tooltip></el-table-column>

        <el-table-column prop="sjtxPackagesName" label="SJTX套餐" width="200" align="center" show-overflow-tooltip></el-table-column>

        <el-table-column label="操作人" width="120" align="center">
          <template #default="scope">
            {{ scope.row ? scope.row.operatorAccount : '' }}
          </template>
        </el-table-column>

        <el-table-column label="号码状态" width="100" align="center">
          <template #default="scope">
            {{ scope.row ? (scope.row.numberState || '-') : '-' }}
          </template>
        </el-table-column>

        <el-table-column label="余额" width="100" align="center">
          <template #default="scope">
            {{ scope.row && scope.row.currentBalance ? scope.row.currentBalance.toFixed(2) : '-' }}
          </template>
        </el-table-column>

        <el-table-column label="充值金额" width="100" align="center">
          <template #default="scope">
            <span v-if="scope.row" style="color: #E6A23C; font-weight: bold;">
              {{ scope.row.rechargeAmount ? scope.row.rechargeAmount.toFixed(2) : '-' }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="立即到账" width="100" align="center">
          <template #default="scope">
            <span v-if="scope.row" style="color: #67C23A;">
              {{ scope.row.immediateArrivalAmount ? scope.row.immediateArrivalAmount.toFixed(2) : '-' }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="次月到账" width="100" align="center">
          <template #default="scope">
            <span v-if="scope.row" style="color: #409EFF;">
              {{ scope.row.nextMonthArrivalAmount ? scope.row.nextMonthArrivalAmount.toFixed(2) : '-' }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="截留金额" width="100" align="center">
          <template #default="scope">
            {{ scope.row && scope.row.needIntercept ? scope.row.needIntercept.toFixed(2) : '-' }}
          </template>
        </el-table-column>

        <el-table-column label="处理类型" width="130" align="center">
          <template #default="scope">
            {{ scope.row ? (scope.row.processType || '-') : '-' }}
          </template>
        </el-table-column>

        <el-table-column label="失败原因" width="200" align="center">
          <template #default="scope">
            <el-tooltip v-if="scope.row && scope.row.failReason" :content="scope.row.failReason" placement="top">
              <span style="color: #F56C6C;">{{ scope.row.failReason }}</span>
            </el-tooltip>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column prop="remark" label="备注" width="200" show-overflow-tooltip></el-table-column>

        <el-table-column label="创建时间" width="160" align="center">
          <template #default="scope">
            {{ scope.row ? formatTime(scope.row.createdAt) : '' }}
          </template>
        </el-table-column>

        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template #default="scope">
            <el-button v-if="scope.row" size="mini" type="primary" @click="showDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
            background
            layout="total, prev, pager, next, sizes"
            :current-page="query.pageIndex"
            :page-size="query.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="pageTotal"
            @current-change="handlePageChange"
            @size-change="handleSizeChange">
        </el-pagination>
      </div>
    </div>

    <!-- 详情对话框 -->
    <el-dialog title="日志详情" v-model:visible="detailVisible" width="800px">
      <el-descriptions :column="2" border v-if="currentLog">
        <el-descriptions-item label="日志类型">
          <el-tag :type="getLogTypeTag(currentLog.logType)" size="small">
            {{ getLogTypeText(currentLog.logType) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="来源">
          <el-tag :type="getSourceTag(currentLog.source)" size="small">
            {{ getSourceText(currentLog.source) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="号码">{{ currentLog.phone }}</el-descriptions-item>
        <el-descriptions-item label="套餐周期">{{ currentLog.yearMonth }}</el-descriptions-item>
        <el-descriptions-item label="操作人">{{ currentLog.operatorAccount }}</el-descriptions-item>
        <el-descriptions-item label="操作人ID">{{ currentLog.operatorId }}</el-descriptions-item>
        <el-descriptions-item label="号码状态">{{ currentLog.numberState || '-' }}</el-descriptions-item>
        <el-descriptions-item label="当前余额">{{ currentLog.currentBalance ? currentLog.currentBalance.toFixed(2) : '-' }}</el-descriptions-item>
        <el-descriptions-item label="运营商套餐">{{ currentLog.packagesName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="SJTX套餐">{{ currentLog.sjtxPackagesName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="套餐类型">{{ currentLog.packageType === 0 ? '整月' : '半月' }}</el-descriptions-item>
        <el-descriptions-item label="云企通价格">{{ currentLog.sjtxPrice ? currentLog.sjtxPrice.toFixed(2) : '-' }}</el-descriptions-item>
        <el-descriptions-item label="迪信通价格">{{ currentLog.dxtPrice ? currentLog.dxtPrice.toFixed(2) : '-' }}</el-descriptions-item>
        <el-descriptions-item label="充值金额">{{ currentLog.rechargeAmount ? currentLog.rechargeAmount.toFixed(2) : '-' }}</el-descriptions-item>
        <el-descriptions-item label="截留金额">{{ currentLog.needIntercept ? currentLog.needIntercept.toFixed(2) : '-' }}</el-descriptions-item>
        <el-descriptions-item label="立即到账金额">{{ currentLog.immediateArrivalAmount ? currentLog.immediateArrivalAmount.toFixed(2) : '-' }}</el-descriptions-item>
        <el-descriptions-item label="次月应到账金额">{{ currentLog.nextMonthArrivalAmount ? currentLog.nextMonthArrivalAmount.toFixed(2) : '-' }}</el-descriptions-item>
        <el-descriptions-item label="次月实际到账金额">{{ currentLog.nextMonthActualArrivalAmount ? currentLog.nextMonthActualArrivalAmount.toFixed(2) : '-' }}</el-descriptions-item>
        <el-descriptions-item label="处理类型">{{ currentLog.processType || '-' }}</el-descriptions-item>
        <el-descriptions-item label="批次号">{{ currentLog.uid || '-' }}</el-descriptions-item>
        <el-descriptions-item label="文件批次号">{{ currentLog.fileBatchNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="支付订单号">{{ currentLog.orderId || '-' }}</el-descriptions-item>
        <el-descriptions-item label="迪信通订单号">{{ currentLog.dxtOrderId || '-' }}</el-descriptions-item>
        <el-descriptions-item label="充值成功">{{ currentLog.rechargeSuccess === true ? '是' : currentLog.rechargeSuccess === false ? '否' : '-' }}</el-descriptions-item>
        <el-descriptions-item label="充值结果">{{ currentLog.rechargeResult || '-' }}</el-descriptions-item>
        <el-descriptions-item label="失败原因" :span="2">
          <span style="color: #F56C6C;">{{ currentLog.failReason || '-' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ currentLog.remark || '-' }}</el-descriptions-item>
        <el-descriptions-item label="次月处理时间">{{ formatTime(currentLog.nextMonthProcessTime) }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatTime(currentLog.createdAt) }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import { getTopUpLogs } from '../api/dijia.js';

export default {
  name: 'DxtPackageTopUpLog',
  data() {
    return {
      loading: false,
      theme: localStorage.getItem('theme'),
      theme3: localStorage.getItem('theme3'),
      theme8: localStorage.getItem('theme8'),
      tableData: [],
      pageTotal: 0,
      tableKey: 0,
      query: {
        phone: '',
        logType: null,
        source: null,
        operatorAccount: '',
        pageIndex: 1,
        pageSize: 20
      },
      detailVisible: false,
      currentLog: null
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      getTopUpLogs(this.query).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.tableData = res.data.list || [];
          this.pageTotal = res.data.total || 0;
        } else {
          this.$message.error(res.message || '查询失败');
        }
      }).catch(err => {
        this.loading = false;
        this.$message.error('查询失败，请稍后再试');
        console.error(err);
      });
    },
    resetQuery() {
      this.query = {
        phone: '',
        logType: null,
        source: null,
        operatorAccount: '',
        pageIndex: 1,
        pageSize: 20
      };
      this.getData();
    },
    handlePageChange(val) {
      this.query.pageIndex = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.query.pageIndex = 1;
      this.getData();
    },
    showDetail(row) {
      this.currentLog = row;
      this.detailVisible = true;
    },
    getLogTypeText(type) {
      const map = {
        'ORDER_CREATE': '订单创建',
        'IMMEDIATE_ARRIVAL': '立即到账',
        'NEXT_MONTH_ARRIVAL': '次月到账'
      };
      return map[type] || type;
    },
    getLogTypeTag(type) {
      const map = {
        'ORDER_CREATE': 'primary',
        'IMMEDIATE_ARRIVAL': 'success',
        'NEXT_MONTH_ARRIVAL': 'warning'
      };
      return map[type] || 'info';
    },
    getSourceText(source) {
      const map = {
        'PUBLIC_ACCOUNT': '公众号',
        'BATCH_TOPUP': '后台批量',
        'FILE_RECHARGE': '文件充值'
      };
      return map[source] || source;
    },
    getSourceTag(source) {
      const map = {
        'PUBLIC_ACCOUNT': 'success',
        'BATCH_TOPUP': 'warning',
        'FILE_RECHARGE': 'danger'
      };
      return map[source] || 'info';
    },
    formatTime(time) {
      if (!time) return '-';
      // 处理 MongoDB 返回的时间格式
      if (typeof time === 'string') {
        return time.replace('T', ' ').substring(0, 19);
      }
      return time;
    }
  }
};
</script>

<style scoped>
.container {
  padding: 20px;
}

.handle-box {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.table {
  width: 100%;
  font-size: 14px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
